(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exodus-release-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-xr-ed-pause]').forEach(function (btn) {
        if (btn.dataset.bound) return;
        btn.dataset.bound = '1';
        var video = btn.parentElement.querySelector('video');
        if (!video) return;
        function set(paused) {
          btn.textContent = paused ? 'Play video' : 'Pause video';
          btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.pause(); set(true); }
        btn.addEventListener('click', function () {
          if (video.paused) { video.play(); set(false); } else { video.pause(); set(true); }
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exodus-release-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('.xr-hero').forEach(function (hero) {
        var video = hero.querySelector('video');
        var btn = hero.querySelector('[data-xr-pause]');
        if (!video || !btn || btn.dataset.bound) return;
        btn.dataset.bound = '1';
        function set(paused) {
          btn.textContent = paused ? 'Play video' : 'Pause video';
          btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        }
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.pause(); set(true); }
        btn.addEventListener('click', function () {
          if (video.paused) { video.play(); set(false); } else { video.pause(); set(true); }
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exodus-release-lookbook"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function bind(look) {
      if (look.dataset.xrBound) return;
      look.dataset.xrBound = '1';
      var track = look.querySelector('[data-xr-track]');
      var slides = track ? track.children : [];
      if (!track || slides.length < 2) return;
      var now = look.querySelector('[data-xr-now]');
      var bar = look.querySelector('[data-xr-bar]');
      var prev = look.querySelector('[data-xr-prev]');
      var next = look.querySelector('[data-xr-next]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function step() {
        var a = slides[0].getBoundingClientRect(), b = slides[1].getBoundingClientRect();
        return b.left - a.left || a.width;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var i = Math.round(track.scrollLeft / step());
        if (track.scrollLeft >= max - 2) i = slides.length - 1;
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (now) now.textContent = pad(i + 1);
        if (bar) bar.style.transform = 'scaleX(' + ((i + 1) / slides.length) + ')';
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      function go(dir) { track.scrollBy({ left: dir * step(), behavior: reduce ? 'auto' : 'smooth' }); }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      });
      window.addEventListener('resize', update);
      update();
    }
    function init(root) { (root || document).querySelectorAll('[data-xr-look]').forEach(bind); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('.xr-look__slide');
      if (slide) slide.scrollIntoView({ block: 'nearest', inline: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
